import { HubConnectionBuilder } from '@microsoft/signalr';
import _ from 'lodash';

import {
  NOT_ADICIONA_NOTIFICACAO_SUCCESS,
  NOT_ATUALIZA_NOTIFICACOES_SUCCESS,
  NOT_MARCAR_NOTIFICACAO_LIDO_FAIL,
  NOT_MARCAR_NOTIFICACAO_LIDO_SUCCESS,
  NOT_NOTIFICACOES_FAIL,
  NOT_NOTIFICACOES_SUCCESS,
  NOT_REGISTRA_NOTIFICACAO_FAIL,
  NOT_REGISTRA_NOTIFICACAO_SUCCESS,
  NOT_TOTAL_NOTIFICACAO_NAO_LIDA,
  NOT_MARCAR_TODAS_NOTIFICOES_LIDAS,
} from './types';
import notificacao from '../api/notificacao';

const baseURL = process.env.REACT_APP_NOTIFICACOES;

const enviaNotificacao = notification => {
  if (Notification.permission === 'granted') {
    const [nomeRemetente] = notification.remetente.nome.split(' ');
    const body = `${_.startCase(
      nomeRemetente.toLowerCase(),
    )} ${notification.mensagem.toLowerCase()}`;

    const opcoes = { body };

    new Notification('Tron Box', opcoes);
  }
};

const contaNotificacoesNaoLidas = notificacoes => ({
  type: NOT_TOTAL_NOTIFICACAO_NAO_LIDA,
  payload: notificacoes.filter(n => !('lidoEm' in n) || n.lidoEm === 0).length,
});

const setAddNotificacaoSuccess = payload => ({
  type: NOT_ADICIONA_NOTIFICACAO_SUCCESS,
  payload,
});

const setNotificacoesSuccess = payload => ({
  type: NOT_NOTIFICACOES_SUCCESS,
  payload,
});

const setNotificacoesFail = () => ({
  type: NOT_NOTIFICACOES_FAIL,
});

const addNotificacao = (payload, dispatch) => {
  dispatch(setAddNotificacaoSuccess(payload));
  enviaNotificacao(notificacao);
};

export const getNotificacoes = (page = 1) => async (dispatch, getState) => {
  const {
    usuario: {
      pessoaLogada: { tenantId },
    },
  } = getState();

  const params = {
    tenantId,
    page,
    modulo: 16,
    limit: 5,
  };

  try {
    const { data } = await notificacao.get('/notificacoes', { params });

    dispatch(setNotificacoesSuccess(data));

    dispatch(contaNotificacoesNaoLidas(data));
  } catch (err) {
    dispatch(setNotificacoesFail());
  }
};

export const signalR = () => (dispatch, getState) => {
  const {
    usuario: {
      pessoaLogada: { usuarioId, tenantId },
    },
  } = getState();

  const hubConnection = new HubConnectionBuilder()
    .withUrl(`${baseURL}/echo`)
    .withAutomaticReconnect()
    .build();

  hubConnection.on('RecebeNotificacaoTenant', data => addNotificacao(data, dispatch));
  hubConnection.on('RecebeNotificacaoUsuarios', data => addNotificacao(data, dispatch));
  hubConnection.on('RecebeNotificacaoModulo', data => addNotificacao(data, dispatch));

  hubConnection
    .start()
    .then(() => {
      hubConnection.invoke('AddToGroup', `${tenantId}${usuarioId}`);
      hubConnection.invoke('AddToGroup', `${tenantId}`);
      hubConnection.invoke('AddToGroup', 'Tron Box');
    })
    .catch(() => dispatch({ type: NOT_REGISTRA_NOTIFICACAO_FAIL }));

  if (Notification.permission !== 'denied') Notification.requestPermission();

  dispatch({ type: NOT_REGISTRA_NOTIFICACAO_SUCCESS });
};

export const marcarLido = id => async (dispatch, getState) => {
  const {
    notificacao: { notificacoes, notificacoesNaoLidas, totalNotificacoes },
  } = getState();

  try {
    const { data } = await notificacao.put(`/notificacoes/${id}/marcar-lido`);
    const updatedNotificacoes = notificacoes.map(item => (item.id === id ? data : item));

    dispatch({
      type: NOT_ATUALIZA_NOTIFICACOES_SUCCESS,
      payload: {
        data: updatedNotificacoes,
        notificationsCount: notificacoesNaoLidas - 1,
        count: totalNotificacoes,
      },
    });

    dispatch({ type: NOT_MARCAR_NOTIFICACAO_LIDO_SUCCESS });
  } catch (err) {
    dispatch({ type: NOT_MARCAR_NOTIFICACAO_LIDO_FAIL });
  }
};

export const marcarTodasComoLidas = () => async (dispatch, getState) => {
  try {
    const {
      notificacao: { notificacoes, totalNotificacoes },
    } = getState();

    const updatedNotificacoes = notificacoes.map(item => {
      if (!item.lidoEm)
        return {
          id: item.id,
          enviadoEm: item.enviadoEm,
          lidoEm: +new Date(),
          mensagem: item.mensagem,
        };

      return item;
    });

    const data = {
      modulo: 16,
      tenantId: sessionStorage.getItem('tenant'),
    };
    const response = await notificacao.put(`/notificacoes/marcar-todos-lido`, data);
    if (response.status)
      dispatch({
        type: NOT_MARCAR_TODAS_NOTIFICOES_LIDAS,
        payload: {
          data: updatedNotificacoes,
          notificationsCount: 0,
          count: totalNotificacoes,
        },
      });
  } catch (error) {
    dispatch({ type: NOT_MARCAR_NOTIFICACAO_LIDO_FAIL });
  }
};
